module.exports = __webpack_public_path__ + "img/bg-m.5cc28f47.jpg";